/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-lines */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import MenusNav from '@base/MenusNav/MenusNav';
import ContentsTable from '@base/ContentsTable/ContentsTable';
import { menus } from '@utils/constants';
import { Fonts, Spacings } from '@styles/index';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import Typography from 'aquilla/core/atoms/Typography';

const TermsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const StyledP1 = styled(Typography)`
  margin-top: 20px;
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: var(--color-text-primary);
`;

const TermsContainer = styled.div`
  li {
    font-weight: ${Fonts.REGULAR};
    font-size: ${Fonts.P1};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
    color: var(--color-text-primary);
  }
`;

const Annexure = styled.div`
  margin-top: 10px;
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: var(--color-text-primary);
  ol {
    counter-reset: item;
    margin-left: -40px;
  }
  li {
    display: block;
  }
  li:before {
    content: counters(item, '.') ' ';
    counter-increment: item;
  }
  .sub-li {
    margin-left: 5px;
  }
`;

const SubText = styled.div`
  margin-left: 40px;
`;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_6B};
  padding-top: 100px;
  margin-top: -100px;
`;

const StyledAnchor = styled.a`
  color: var(--color-i-blue);
  margin-left: ${Spacings.SPACING_1B};
`;

const tableData = [
  { label: 'A. Placement Process', id: 'placement-process' },
  { label: 'B. Placement Refund Process', id: 'refund-process' },
  {
    label: 'C. General Terms',
    id: 'general-terms'
  },
  {
    label: 'D. Governing Laws and Jurisdiction',
    id: 'governing-laws'
  },
  {
    label: 'E. AMENDMENTS',
    id: 'amendments'
  }
];

const PlacementProtectionPolicy = () => {
  const router = useRouter();
  const { pathname } = router;
  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>

      <RightContainer>
        <TermsWrapper>
          <TermsContainer>
            <H2>
              Unacademy Core Engineering Placement Protection Program - Terms
              and Conditions
            </H2>
            <br />
            <br />
            <ContentsTable data={tableData} />

            <P1>
              Sorting Hat Technologies Private Limited (hereinafter referred to
              as <b>“Unacademy”</b>) has created the Unacademy Core Engineering
              Placement Protection Program <b>(“Program”).</b> The Program aims
              to secure interview opportunities for CE Learners (defined later)
              with companies/firms associated with the Program{' '}
              <b>(“Associated Companies”)</b>, that are looking to hire for
              relevant engineering roles <b>(“Placement”)</b>. These terms and
              conditions are applicable to any learner who has taken a Plus or
              Iconic Subscription to any course specified under the Core
              Engineering category <b>(“CE Course(s)”)</b> on the Unacademy
              Platform <b>(“CE Learner(s)”)</b>.
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              Unacademy permits you to claim a Placement Refund (defined below)
              in connection with the CE Placement Process, provided you satisfy
              the terms and conditions herein (“collectively herein referred to
              as <b>“CE Placement Protection Terms/ Terms”</b>).
            </P1>
            <P1>
              <br />
            </P1>
            <P1>
              All capitalized terms are defined/have the meaning assigned to it
              under the CE Placement Protection Terms or under the relevant
              Platform Terms. In other words, if you find any word herein that
              has its first letter capitalized, then it means that we have
              explained the meaning that such word has in the context of these
              CE Placement Protection Terms; if not here, then it will be
              provided in the relevant Platform Terms – when we refer to any
              such term in these CE Placement Protection Terms, we will try and
              specify where in these terms and conditions and/or other Platform
              Terms you can find the meaning/definition.
            </P1>
            <P1>
              <br />
            </P1>
            <br />
            <br />

            <a name="placement-process">
              <StyledH3>A. Placement Process</StyledH3>
            </a>
            <ol type="1">
              <li>
                <P1>
                  <b>Eligibility Criteria for Placement Process:</b> To be
                  eligible to participate in the Placement process through the
                  Program, a CE Learner shall be required to fulfil all the
                  following conditions/requirements (as may be applicable)
                  <b> (“Placement Process Criteria”):</b>
                </P1>
                <ol type="a">
                  <li>
                    You hold a current, active subscription to any CE Course;
                  </li>
                  <li>
                    You have completed seven modules of the CE Course before the
                    expiry of the time period for which CE Course has been
                    purchased <b>(“Subscription Period”)</b>.(In order to
                    successfully complete a module, you would be required to
                    score at least 70% in test, projects and viva associated
                    with each module and comply with any other instructions
                    communicated by Unacademy.)
                  </li>
                  <li>
                    You shall be above 18 (eighteen) years of age and below 35
                    (thirty-five) years of age;
                  </li>
                  <li>
                    You must have completed your Bachelors in Engineering and
                    hold a B.Tech degree which is recognized in India;
                  </li>
                  <li>
                    You shall hold valid marksheets/ documents which need to be
                    provided for evaluation when required/requested;
                  </li>
                  <li>
                    You shall be legally authorized to work in India without
                    sponsorship;
                  </li>
                  <li>
                    You shall be proficient in English (written and spoken);
                  </li>
                  <li>
                    You must have paid all CE Course fees for the applicable
                    course through any of the available payment plans.
                  </li>
                  <li>
                    You must not have defaulted on any of your EMI payments in
                    respect of any loans availed by you through the Platform
                    (valid only if you have paid for the course using the
                    monthly EMIs option).
                  </li>
                  <li>
                    You must be available for joining the company whose offer
                    you choose to accept within 30 (thirty) days from the date
                    of accepting the offer.
                  </li>
                  <li>
                    You must have completed requisite portion of the CE Course
                    to which you have subscribed as may be prescribed by
                    Unacademy or satisfied any such additional conditions as may
                    be communicated by Unacademy.
                  </li>
                  <li>
                    You may be required to provide your resume, details relating
                    to your education, work experience if any, and if required,
                    submit proof of the same and any other details as may be
                    required by Unacademy in order to facilitate Placements,
                    including any personal identification documents.
                  </li>
                  <li>
                    A CE Learner holding an Iconic Subscription should have
                    minimum 1 (one) year of work experience.
                  </li>
                </ol>
                <P1>
                  <br />
                </P1>
              </li>
              <li>
                <P1>
                  <b>Onboarding to the Placement Process:</b> To initiate the
                  Placement process, subject to your eligibility, you will be
                  asked to share details with respect to your education and work
                  experience, including but not limited to your resume, relevant
                  certificates, any personal identification documents and/or
                  Personal Information. The information we need from you will be
                  requested via email or through other modes of communication.
                  You are required to share all the requested information{' '}
                  <b>within 48 (forty-eight) hours</b> from receipt of the
                  communication from us,{' '}
                  <b>or within such duration specified in the communication</b>,
                  in the manner as may be detailed in the communication. By
                  submitting the requested information, you undertake that all
                  information provided by you is factually correct and
                  verifiable. Any Personal Information collected from you shall
                  be processed in accordance with{' '}
                  <a href="https://unacademy.com/privacy">
                    {' '}
                    Unacademy’s Privacy Policy
                  </a>
                  .
                </P1>
                <P1>
                  <br />
                </P1>
                <P1>
                  <b>Note:</b> The Placement process will only start once we
                  receive all the requested information within the timelines
                  stated herein above.
                </P1>
                <P1>
                  <br />
                </P1>
              </li>
              <li>
                <P1>
                  <b>Work Experience:</b> Please note that a company may require
                  a specific number of years of experience to be considered for
                  a job. If you have experience which is not relevant to the
                  position available you will be deemed ‘Fresher’ or
                  ‘Non-Experienced’, or you may be ineligible to proceed with
                  the Placement process.
                </P1>
                <P1>
                  <br />
                </P1>
                <P1>
                  We will try our best to align relevant opportunities available
                  through the Program. However, we do not guarantee any minimum
                  or a maximum number of Placement opportunities.
                </P1>
                <P1>
                  <br />
                </P1>
              </li>
              <li>
                <P1>
                  <b>Consent and Waiver for use of Personal Attributes:</b> You
                  hereby consent to the use by Unacademy and its affiliates, at
                  its sole discretion, of your name, photograph, videos, voice
                  recordings, statements and/or testimonials{' '}
                  <b>(“Personal Attributes”)</b> for the purpose of publication,
                  advertising, promotion on its online platforms, including but
                  not limited to the Unacademy Platform, and through any mode,
                  medium, platform and/or format, including without limitation,
                  in newspapers, magazines, other print media, on television,
                  radio, internet and other electronic and/or in mailings for
                  educational awareness. Further you release, waive, and
                  discharge claims of any kind or nature arising out of or
                  relating to the use of your Personal Attributes against
                  Unacademy and its affiliates or any person or firm authorized
                  by Unacademy to publish the same in accordance with the terms
                  hereof. Such release, waiver and discharge shall also extend
                  to all group companies, affiliated companies, subsidiaries,
                  shareholders, directors, officers, employees, agents and
                  assigns of Unacademy and any publishers of the Personal
                  Attributes in accordance with the terms hereof. Such a release
                  shall be binding on the Participant, his/her respective
                  successors, heirs, assigns, executors, administrators, spouse
                  and next of kin.
                </P1>
                <P1>
                  <br />
                </P1>
              </li>
              <li>
                <P1>
                  <b>Interview Process:</b> Unacademy shall arrange interviews
                  between an eligible candidate and Associated Companies. You
                  are required to respond to the interview invite(s) with either
                  an acceptance or rejection within 6 (six) hours of receiving
                  the invite or within such duration as may be specified in the
                  invite email.
                </P1>
                <P1>
                  <br />
                </P1>
                <P1>Further, you shall adhere to the below terms:</P1>
                <ol type="a">
                  <li>
                    You are required to attend all interviews you have accepted
                    the invites for, and you will not reschedule the interviews.
                  </li>
                  <li>
                    You will not reject more than 2 (two) interview invites, and
                    you will share the appropriate and valid reasons for
                    rejecting the interview invites.
                  </li>
                </ol>
                <br />
              </li>
              <li>
                <P1>
                  <b>Placement Support:</b> You will receive placement support
                  from Unacademy until the occurrence of any of the following
                  events:
                </P1>
                <ol type="a">
                  <li>
                    You have accepted an offer with CTC greater than INR 2.5
                    LPA; or
                  </li>
                  <li>
                    You have rejected 2 (two) offers for Placement from
                    Associated Companies; or
                  </li>
                  <li>
                    On the occurrence of any event specified under the{' '}
                    <b>‘Withdrawal’</b> or <b>‘Disqualification’</b> sections
                    below.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <P1>
                  <b>Withdrawal from the Program:</b> On the occurrence of any
                  of the following events, we will assume your withdrawal from
                  the Placement process, and thereafter Unacademy will not be
                  obligated to make available any Placement opportunities to
                  you:
                </P1>
                <ol type="a">
                  <li>
                    You do not furnish the requested information within the
                    timelines stated in <b>‘Onboarding to Placement Process’</b>
                    section above; or
                  </li>
                  <li>
                    You do not adhere to the preferences that you have shared
                    during the onboarding process; or
                  </li>
                  <li>
                    You fail to attend an interview you had accepted the invite
                    for; or
                  </li>
                  <li>
                    You reject 3 (three) interviewing opportunities offered by
                    companies registered with the Program.
                  </li>
                  <li>
                    You have defaulted on your EMIs for 2 (two) months or more
                    (valid only if you have subscribed using the monthly EMI
                    payment option).
                  </li>
                  <li>
                    You have accepted a job offer outside the Placement process
                    offered by Unacademy.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <P1>
                  <b>Disqualification from the Placement Program: </b> To ensure
                  that the integrity of our Placement Programs is maintained, we
                  will have the right to disqualify you from the Program if –
                </P1>
                <ol type="a">
                  <li>
                    the details furnished by you are found to be factually
                    incorrect; or
                  </li>
                  <li>
                    it is brought to Unacademy’s notice that you have
                    misconducted yourself in any form with Unacademy employees,
                    Associated Companies or any personnel associated with
                    Unacademy; or
                  </li>
                  <li>
                    You have received an offer from the companies registered
                    with Unacademy as part of the Program and chosen to not
                    inform Unacademy about it.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <P1>
                  <b>Consequences of Withdrawal and/or Disqualification: </b>{' '}
                  The consequences of your withdrawal or <b>disqualification</b>{' '}
                  from the process may lead to one or more of the following,
                  depending on the reasons and their severity for the withdrawal
                  or disqualification:
                </P1>
                <ol type="a">
                  <li>
                    Your participation in the Placement Program will be halted
                    and Unacademy shall no longer be obliged to offer Placement
                    support to you;
                  </li>
                  <li>
                    Any offer that has been extended to you by any Associated
                    Companies may be rescinded.
                  </li>
                  <li>You shall no longer be eligible for Placement Refund.</li>
                </ol>
              </li>
              <br />
            </ol>
            <br />

            <a name="platform">
              <StyledH3>B. Placement Refund Process:</StyledH3>
            </a>
            <ol type="1">
              <li>
                <b>Placement Refund:</b> Subject to the CE Placement Protection
                Terms, Unacademy shall permit you to claim a Placement Refund (
                <i>defined below</i>) subject to the Placement Refund
                Eligibility Criteria (<i>defined below</i>) if a CE Learner who
                has participated in the Placement process has not been able to
                secure a job offer within the Placement Period (
                <i>defined below</i>) .
              </li>
              <li>
                <b>Placement Refund Eligibility Requirements:</b> A CE Learner
                may be eligible for a Placement Refund if he/she fulfils the
                following criteria (“Placement{' '}
                <b>Refund Eligibility Criteria</b>”):
                <ol type="a">
                  <li>
                    Must have failed to receive any job offer from any
                    Associated Company within 6 (six) months or 180 days of
                    completion of 7(seven) modules of the CE Course (“
                    <b>Placement Period</b>”), provided that he/she completed
                    seven modules of the CE Course before the expiry of the
                    Subscription Period In order to successfully complete a
                    module, you would be required to score at least 70% in test,
                    projects and viva associated with each module and comply
                    with any other instructions communicated by Unacademy.)
                  </li>
                  <li>
                    Must have submitted any documents requested by Unacademy
                    within the stipulated timelines for the Placement Process;
                  </li>
                  <li>
                    Must have complied with the Placement Eligibility Criteria
                    and the other terms applicable to Placements (in section A
                    above);
                  </li>
                  <li>
                    Must not have withdrawn or/ been disqualified from the
                    Program;
                  </li>
                  <li>
                    must pass any and all background verification checks and
                    fitness tests that an Associated Company may want to run;
                  </li>
                  <li>
                    must not express the intention in writing to withdraw from
                    the Placement process or make a request in writing to
                    postpone or reschedule the Placement process;
                  </li>
                  <li>
                    must track all job search activity including but not limited
                    to application confirmation emails, texts, registration
                    verifications, etc and reply / reach out (if required)
                    within the timeline prescribed in all such communications;
                  </li>
                  <li>
                    must have attended any and all preparatory sessions
                    (including mock interviews and training sessions) as
                    directed by the Unacademy team within any such timeline
                    prescribed by Unacademy;
                  </li>
                  <li>
                    must have submitted his/her latest tax filing certificates /
                    Form 26 AS for the last 4 quarters as a verification (if
                    required);
                  </li>
                </ol>
                <br />
                <P1>
                  <i>General Terms</i>
                </P1>
                <ol type="a">
                  <li>
                    must not engage in any activity that brings Unacademy or any
                    of its affiliates into disrepute;
                  </li>
                  <li>
                    must not, either presently or in the past, be involved in
                    any misconduct or malpractice of any kind;
                  </li>
                  <li>
                    must not commit acts of dishonesty during the application
                    process and the duration of the Refund Window;
                  </li>
                  <li>must not submit any factually incorrect details ;</li>
                  <li>
                    must not change your job search strategy during the Refund
                    Window, including without limitation to industry, unless
                    agreed to in advance with Unacademy;
                  </li>
                  <li>
                    must not behave inappropriately with any Unacademy team
                    members, associates, other participants of the CE Courses or
                    Associate Companies;
                  </li>
                  <li>
                    must not use unfair means during online examinations, or
                    while doing hands-on assignments and assessments, by
                    indulging in activities like copying, discussions, using
                    technology-based instruments, or other means to cheat. There
                    is zero tolerance towards any form of copying (as may be
                    determined by Unacademy or its representatives at their sole
                    discretion);
                  </li>
                  <li>
                    must not be in-disciplined, which shall include, but not be
                    limited to mis-behaviour, nuisance, brawl, use of foul
                    language posting objectionable material, use of unfair means
                    at the time of assessments/interaction, being drunk, having
                    consumed narcotics substances, and indulging in any act or
                    omission which amounts to discouraging / demeaning/
                    hampering the CE Course structure during the CE Course;
                  </li>
                  <li>
                    must not have received and/or acted upon any Placement
                    opportunities outside of the Platform;
                  </li>
                  <li>
                    must not have rejected a job offer on the pretext of
                    compensation, designation, lock-in conditions, location etc;
                  </li>
                  <li>
                    must have paid all dues to Uncademy or loan partner on-time
                    and there is no delay from CE Learner’s side.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <b>Placement Refund Rules</b>
                <ol type="a">
                  <li>
                    Subject to the CE Placement Protection Terms, if you would
                    like to avail of a Placement Refund under this CE Placement
                    Protection Program, you may write to{' '}
                    <StyledAnchor href="mailto:placements@unacademy.com">
                      placements@unacademy.com
                    </StyledAnchor>{' '}
                    from your registered email address during the Refund Window
                    (<i>defined below</i>), provided you meet the Refund
                    Eligibility Criteria, as applicable. If the request is
                    accepted by Unacademy:
                    <ol type="i">
                      <li>
                        For Iconic Subscriptions- 100% of the CE Course fee (“
                        <b>Placement Refund</b>”) shall be refunded to you,
                        subject to any deductions as may be applicable as per
                        the terms and conditions set out in this CE Placement
                        Protection Terms.
                      </li>
                      <li>
                        For Plus Subscriptions- 50% of the CE Course fee shall
                        be refunded (“<b>Plus Placement Refund</b>”) to
                        you,subject to any deductions as may be applicable as
                        per the terms and conditions set out in this CE
                        Placement Protection Terms. It is clarified that Iconic
                        Placement Refund and Plus Placement Refund shall
                        collectively be referred to as placement refund (“
                        <b>Placement Refund</b>”).
                      </li>
                    </ol>
                  </li>
                  <li>
                    A request for a Placement Refund shall be made within 30
                    days following the Placement Period (“<b>Refund Window</b>
                    ”). Unacademy shall not be liable to provide any refunds
                    with respect to any requests for cancellations and refund
                    received by Unacademy after the expiry of the Refund Window.
                  </li>
                  <li>
                    To process the Placement Refund, our team may contact you to
                    verify your details within 4 (four) working days from the
                    date of receipt of request. It is mandatory for you to raise
                    your request for Placement Refund from your registered email
                    address only. Pursuant to the same, our representative may
                    contact you for completing any forms required for processing
                    the refund which you are required to complete and send back
                    as per the timelines communicated to you.
                  </li>
                  <li>
                    You shall receive the Placement Refund in the same payment
                    source you had used to make the payment to register for the
                    CE Course. In case there are any difficulties or errors in
                    processing the payment to your source account, you may be
                    requested to share details of an alternate bank account with
                    requisite documents such as cancelled cheque pertaining to
                    the relevant bank account for verification purpose. In the
                    event you fail to provide the complete details (as may be
                    requested by Unacademy) of the alternate bank account within
                    (fourteen) 14 calendar days from a request by Unacademy in
                    writing, Unacademy shall not be liable to refund the
                    Placement Refund to you.
                  </li>
                  <li>
                    <P1>
                      Please note that the refund of the Placement Refund shall
                      be subject to deductions (at actuals) towards outstanding
                      loan amount (if any), payment gateway charges, interest
                      and taxes, as applicable. The deduction amount shall be
                      calculated based on payment mode and amount charged by the
                      payment partner / loan partner. The applicable deductions,
                      as applicable, are mentioned below for your reference–-
                    </P1>
                    <ol type="i">
                      <li>Outstanding loan amount (if any)</li>
                      <li>
                        Payment Gateway charges including interest charged under
                        No-Cost EMI.
                      </li>
                      <li>Any charges/interest deducted by loan partner</li>
                      <li>Any statutory taxes</li>
                    </ol>
                  </li>
                  <li>
                    Whilst every effort is made to provide you an excellent
                    learning experience, we reserve the right to withdraw or
                    cancel the Placement Refund in any event where we have
                    identified a fraudulent activity attributable to the CE
                    Learner requesting such Placement Refund. In such
                    circumstances there shall be no re-attempt of refund made to
                    such CE Learner.
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <b>Timeline for Processing of Refund</b>
                <ol type="a">
                  <li>
                    We may take up to 14 (fourteen) Business Days (defined
                    below) from the date of receipt of request to accept the
                    request for Placement Refund. After the Placement Refund is
                    accepted by Unacademy, it may take up to 90 (ninety)
                    Business Days for the amount to reflect in your account.
                    Please do contact your respective bank or the source payment
                    provider. A “<b>Business Day</b>” is defined as any day that
                    is not Saturday, Sunday, public holiday or bank holiday in
                    India or in the State where the Unacademy office(s) is/are
                    located in India.
                  </li>
                  <li>
                    If the amount does not reflect in your account post 90
                    (ninety) Business Days from the date of processing, you can
                    contact us at{' '}
                    <StyledAnchor href="mailto:core-engineering@unacademy.com ">
                      core-engineering@unacademy.com
                    </StyledAnchor>
                    .
                  </li>
                  <li>
                    Not with standing the other provisions of this CE Placement
                    Protection Terms, if you have reached out to us after the
                    Refund Window, you shall not be eligible for a Placement
                    Refund under this CE Placement Protection Terms. For the
                    avoidance of doubt, please note that we shall not entertain
                    any Placement Refund requests post expiry of the Refund
                    Window irrespective of the reason.
                  </li>
                </ol>
              </li>
            </ol>
            <br />
            <br />
            <a name="general-terms">
              <StyledH3>C. General Terms</StyledH3>
            </a>

            <P1>
              These CE Placement Protection Terms have to be accepted before
              paying the CE Course Fee / enrolling for the CE Course along with
              the Platform Terms. In the event, you are not willing to accept
              the CE Placement Protection Terms, then you shall not be
              authorized or allowed to opt for a CE Course offered by Unacademy.
              On payment of the CE Course Fee and enrolling for a CE Course, the
              CE Learner confirms that the CE Learner has read, understood, and
              agreed to all the terms and conditions of a CE Course as mentioned
              in this document and the Platform Terms and has not relied on any
              other oral representation by Unacademy or any other third party.
            </P1>
            <br />
            <br />

            <a name="governing-laws">
              <StyledH3>D. Governing Laws and Jurisdiction</StyledH3>
            </a>
            <P1>
              This Policy shall constitute an agreement between you and
              Unacademy (individually “<b>Party</b>” and collectively, “
              <b>Parties</b>”) and shall be governed by and construed in
              accordance with the laws of India, without reference to principles
              of conflict of laws. In the event of any dispute arising out of,
              under, or in relation to, this CE Placement Protection Terms, the
              Parties agree to submit such dispute to arbitration by a sole
              arbitrator appointed jointly by both Parties, failing which such
              arbitrator shall be appointed in accordance with the Arbitration
              and Conciliation Act, 1996. The arbitration proceedings shall be
              held in accordance with the rules framed under the provisions of
              the Arbitration and Conciliation Act, 1996 (which rules are deemed
              to be incorporated in this Agreement by reference herein) and
              shall be held in Bangalore. All proceedings of such arbitration
              shall be in the English language. The arbitral awards rendered
              shall be final and binding and shall not be subject to any form of
              appeal. The successful Party may seek to enforce the award in an
              appropriate jurisdiction, including India. Each Party shall bear
              its own costs and expenses, incurred in connection with the
              arbitration proceedings. Nothing herein shall preclude either
              Party from seeking interim or permanent equitable or injunctive
              relief, or both, from the courts at Bangalore, India which shall
              have exclusive jurisdiction to determine any dispute arising under
              this Agreement. The pursuit of equitable or injunctive relief
              shall not be a waiver of the right of the Parties to pursue any
              remedy for monetary damages through the arbitration
            </P1>
            <br />
            <br />

            <a name="amendments">
              <StyledH3>E. AMENDMENTS</StyledH3>
            </a>
            <P1>
              Unacademy reserves the right to amend, modify, withdraw or
              substitute any part of this CE Placement Protection Terms without
              any prior notice and you agree to be bound by the same. The
              changes may be necessitated due to Unacademy’s focus on continuous
              improvement of the processes and services, research and
              development in the methodologies, pedagogy, technology
              obsolescence, industry requirements, and statutory compliances.
              Unacademy shall endeavour to notify you of any changes/amendments
              to this CE Placement Protection Terms, however you are advised to
              check our Platform frequently to keep yourself updated regarding
              any changes, including to the Platform Terms. You would be
              required to read and abide by such amendments, if any.
            </P1>
            <br />
            <Typography variant="h7">
              <b>
                Annexure I- Additional Terms applicable to CE Learner who has
                purchased an Iconic Subscription
              </b>
            </Typography>
          </TermsContainer>
          <Annexure>
            <ol>
              <li>
                <i>Complimentary Laptop:</i>
                <ol className="sub-li">
                  <li>
                    A CE Learner may be eligible to a laptop provided that they
                    have made the payment for the CE Course through credit/debit
                    card or net banking.{' '}
                  </li>
                  <li>
                    The make and model of the laptop shall be as decided by
                    Unacademy and no requests for any upgrade shall be
                    entertained.
                  </li>
                  <li>
                    Unacademy may decide, at its sole discretion, either to
                    place an order for a laptop with the retailer/manufacturer
                    on behalf of the CE Learner or send gift vouchers to the CE
                    Learner who may use the same to purchase the laptop.
                  </li>
                  <li>
                    Where the CE Learner receives gift vouchers to purchase a
                    laptop, the CE Learner is free to pay extra for any upgraded
                    model of the laptop, including applicable taxes if any,
                    subject to availability, after consultation with the
                    manufacturer/retailer.
                  </li>
                  <li>The gift vouchers shall not be redeemable as cash.</li>
                  <li>
                    Where Unacademy places an order for a laptop on behalf of
                    the CE Learner, the delivery of the laptop to the CE Learner
                    shall be subject to the delivery timeline of the
                    manufacturer/retailer and Unacademy shall not be responsible
                    for the same.
                  </li>
                  <li>
                    Unacademy shall not be responsible for paying any applicable
                    taxes, fee, charges etc, related to the laptop.
                  </li>
                  <li>
                    The CE Learner shall be eligible for a laptop upon providing
                    sufficient information as may be required by Unacademy
                    within the prescribed timelines.
                  </li>
                  <li>
                    The CE Learner shall receive the gift vouchers to purchase
                    the laptop within 90 (ninety) days from the date of
                    enrolment to the program subject to providing details as
                    requested by Unacademy.
                  </li>
                </ol>
              </li>
              <li>
                Salary Protection Program:
                <ol className="sub-li">
                  <li>
                    In order to be eligible for the salary protection program (“
                    <b>Salary Protection Program</b>”) a CE Learner must:
                    <br />
                    <SubText>
                      a. &nbsp;&nbsp;be a working professional with a minimum of
                      one year of experience at the time of enrolling for the
                      Iconic Subscription;
                      <br />
                      b. &nbsp;&nbsp; submit the last 3 (three) months’ salary
                      slips within 7(seven) days of such a request communicated
                      by Unacademy at the time of enrollment or any other
                      timeline as may be communicated by Unacademy.
                    </SubText>
                  </li>
                  <li>
                    A CE Learner may be eligible to receive an Iconic Placement
                    Refund, where a CE Learner has not received a Salary Hike (
                    <i>defined below</i>) in the new job secured through the
                    Placement process, within the Placement Period.{' '}
                  </li>
                  <li>
                    It is clarified that a salary hike shall mean any increase
                    from the amount received as salary/fees/compensation by the
                    CE Learners in their previous job role (“
                    <b>Previous Salary</b>”) within any organization,
                    consultancy etc (“<b>Salary Hike</b>”).
                  </li>
                  <li>
                    Where the CE Learner has received an increased salary amount
                    as part of their Previous Salary due to any appraisals
                    conducted and the same has been captured in the salary slip
                    submitted by the CE Learner at the time of enrolment, the
                    increased salary pursuant to the appraisal shall be
                    considered as the Previous Salary.
                  </li>
                  <li>
                    Any variable component which forms a part of the CE
                    Learner’s package in the previous role shall not be
                    considered in the determination of Previous Salary.
                  </li>
                  <li>
                    A CE Learner with an Iconic Subscription shall be eligible
                    to receive an Iconic Placement Refund where he/she is unable
                    to secure a job through the Placement process as outlined in
                    Part B or does not receive a Salary Hike where he/she has
                    secured a job through the Placement process as outlined in
                    Part B. In either case, the procedure for availing Iconic
                    Placement Refund shall be as outlined in Part B of these
                    Terms.
                  </li>
                </ol>
              </li>
              <li>
                Paid Internship:
                <ol className="sub-li">
                  <li>
                    Unacademy shall arrange a three-month paid internship for CE
                    Learners who complete three modules with any Associated
                    Company at a location which shall be determined by the
                    Associated Company (“<b>Internship</b>”). (In order to
                    successfully complete a module, you would be required to
                    score at least 70% in test, projects and viva associated
                    with each module and comply with any other instructions
                    communicated by Unacademy.)
                  </li>
                  <li>
                    Unacademy shall endeavour to match the background and work
                    experience of the CE Learner with role/team at the
                    Associated Company where the Internship is offered.
                  </li>
                  <li>
                    The Internship shall be arranged within three months of the
                    CE Learner having completed three modules ("Internship
                    Window”).
                  </li>
                  <li>
                    The CE Learner shall receive a minimum monthly stipend of
                    Rs.10,000 ( Rupees Ten Thousand only) (“<b>Stipend</b>”)
                    during the Internship which shall be paid by the Associated
                    Company.
                  </li>
                  <li>
                    The CE Learner shall attend interviews, if any, arranged by
                    Unacademy, with an Associated Company for selection to the
                    Internship.
                  </li>
                  <li>
                    In the event the CE Learner rejects an offer for Internship,
                    Unacademy shall not be under any further obligation to
                    secure another Internship for the CE Learner.
                  </li>
                  <li>
                    In the event the Associated Company terminates the
                    Internship due to any misconduct of the Learner, Unacademy
                    shall not be obligated to secure another Internship for the
                    CE Learner.
                  </li>
                  <li>
                    {' '}
                    Unacademy shall not bear any expenses incurred by the CE
                    Learner for the duration of the Internship.
                  </li>
                  <li>
                    In the event, Unacademy is unable to arrange an Internship
                    for the CE Learner within three months of completion of
                    three modules, Unacademy shall pay the Stipend amount to the
                    CE Learners, subject to CE Learners writing to Unacademy
                    within two weeks from the end of the Internship Window (“
                    <b>Stipend Window</b>”). Unacademy shall not be liable to
                    provide any Stipend in respect of non-availability of
                    Internships after the expiry of the Stipend Window.
                    Unacademy may request you to provide requisite details,
                    including bank account details and KYC details for
                    verification within the timelines communicated by Unacademy.
                    If the Stipend amount does not reflect in your account post
                    90 (ninety) Business Days from the date on which you have
                    written to us, you can contact us at{' '}
                    <StyledAnchor href="mailto:core-engineering@unacademy.com">
                      core-engineering@unacademy.com
                    </StyledAnchor>{' '}
                    .
                  </li>
                </ol>
              </li>
            </ol>
          </Annexure>
        </TermsWrapper>
        <StyledP1 variant="p1">
          <i>Updated as on 1st February 2023</i>
        </StyledP1>
      </RightContainer>
    </>
  );
};

PlacementProtectionPolicy.pageInfo = {
  name: 'Unacademy Placement Protection Policy',
  isMWebSupported: true,
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default PlacementProtectionPolicy;
PlacementProtectionPolicy.Layout = Layout;
PlacementProtectionPolicy.Wrapper = PageReduxProvider;
